export const PREVIEW_CONTENT = {
  title: 'Try translating this text!',
  description:
    'Switch the language to see how the widget works. Just like this, all the content on your website will be translated into the selected language.'
};

export const PREVIEW_ORIGINAL_TEXT_ATTRIBUTE =
  'data-website-translator-original-text';

const PREVIEW_CONTENT_SELECTOR = `[${PREVIEW_ORIGINAL_TEXT_ATTRIBUTE}]`;

export function restorePreviewContent() {
  document
    .querySelectorAll<HTMLElement>(PREVIEW_CONTENT_SELECTOR)
    .forEach((element) => {
      const originalText = element.getAttribute(
        PREVIEW_ORIGINAL_TEXT_ATTRIBUTE
      );

      if (originalText !== null) {
        element.textContent = originalText;
      }
    });
}
